import React from 'react';

function LoadingAnimation() {
  return (
    <div className="pulse-container">
      <div className="pulse"></div>
    </div>
  );
}

export default LoadingAnimation;
